/**
 * @fileoverview CSS module for styling instructions sections
 *
 * @example
 * // Usage in component:
 * import styles from './Instructions.module.css';
 *
 * <div className={styles.container}>
 *   <h2>Instructions</h2>
 *   <ul>
 *     <li>Instruction 1</li>
 *     <li>Instruction 2</li>
 *   </ul>
 * </div>
 */

.container h2 {
    min-height: 128px;
}

.container ul {
    padding: 0;
    margin: 0 0 0 20px;
    display: flex;
    gap: 12px;
    flex-direction: column;
}

.container img {
    vertical-align: middle;
}

.container li {
    padding-left: 8px;
}

.instructions {
    display: flex;
    gap: 0.75rem;
    padding: 1rem;
    background-color: var(--indigo50);
    border-radius: 12px;
    font-weight: 300;
}

.instructions h4 {
    font-weight: 500;
    margin: 0 0 12px;
}

.instructions h4:not(:first-of-type) {
    margin: 20px 0 12px;
}

.instructions b,
.instructions strong {
    font-weight: 500;
}

.instructions img {
    display: inline;
}

.spacer {
    height: 16px;
    margin: 0;
}

@media only screen and (min-width: 768px) {
    .container h2 {
        min-height: 64px;
    }
}
